<template>

    <v-card
      class="ids-geographic-filter px-2"
    >

      <ids-geo-selector
        ref="idsCountrySelector"
        geoType="country"
        :geoList="countries"
        :selection="countrySelection"
        headerText="Land"
        placeHolderText="Bitte wählen Sie eine Land aus"
        :loading="countryLoading"
        @ids-geo-selection-change="onGeoSelectionChange"
      />

      <ids-geo-selector
        v-if="showRegion"
        ref="idsRegionSelector"
        geoType="region"
        :geoList="regions"
        :selection="regionSelection"
        headerText="Region"
        placeHolderText="Bitte wählen Sie eine Region aus"
        :loading="regionLoading"
        @ids-geo-selection-change="onGeoSelectionChange"
      />

      <ids-geo-selector
        v-if="showDistrict"
        ref="idsDistrictSelector"
        geoType="district"
        :geoList="districts"
        :selection="districtSelection"
        headerText="Landkreise"
        placeHolderText="Bitte wählen Sie eine Kreis aus"
        :loading="districtLoading"
        @ids-geo-selection-change="onGeoSelectionChange"
      />

    </v-card>

</template>

<script>
import IdsGeoSelector from './IdsGeoSelector.vue';
import JsUtil from '../../../util/JsUtil';
import DgdDataLoader from '../../DgdDataLoader';

export default {
  name: 'ids-geographic-filter',
  components: {
    'ids-geo-selector': IdsGeoSelector
  },
  props: {
    countries: { type: Array, required: true },
    countrySelection: { type: Object, required: false },
    regionSelection: { type: Object, required: false },
    districtSelection: { type: Object, required: false },
    locationType: { type: String, required: true }
  },
  data () {
    return {
      regions: [],
      districts: [],
      dataCountrySelection: JsUtil.cloneObject(this.countrySelection),
      dataRegionSelection: JsUtil.cloneObject(this.regionSelection),
      dataDistrictSelection: JsUtil.cloneObject(this.districtSelection),
      countryLoading: false,
      regionLoading: false,
      districtLoading: false
    }
  },

  watch: {
    async locationType (newValue) {
      // when location type changes we need to reset and reload the select boxes
      this.setNewCountry({ clientId: null }); // => reset selects
      // re-load the countries for changed location type
      this.regions = await DgdDataLoader.getCountryList(this.locationType);
    }
  },

  mounted () {
    // restore the prev. selection without resetting as it would be on
    // selection of a user
    const skipReset = true;
    if (this.dataCountrySelection) {
      this.setNewCountry(this.dataCountrySelection, skipReset);
    }
    if (this.dataCountrySelection) {
      this.setNewRegion(this.dataRegionSelection, skipReset);
    }
    if (this.dataDistrictSelection) {
      this.setNewDistrict(this.dataDistrictSelection);
    }
  },
  computed: {
    showRegion () {
      return JsUtil.isObject(this.dataCountrySelection);
    },
    showDistrict () {
      return JsUtil.isObject(this.dataRegionSelection);
    }
  },
  methods: {
    /**
     * Handler for 'ids-geo-selection-change' of <ids-geo-selector>.
     */
    async onGeoSelectionChange (geoType, newGeoObj) {
      let geoObj = newGeoObj;
      if (geoType === 'country') {
        this.setNewCountry(geoObj);
      } else if (geoType === 'region') {
        this.setNewRegion(geoObj);
      } else if (geoType === 'district') {
        this.setNewDistrict(geoObj);
      }
    },

    /**
     * Sets the new country selection and loads underlying regions.
     */
    async setNewCountry (countryObj, skipReset) {
      if (countryObj.clientId === null) {
        this.resetRegion();
        this.resetCountry();
        return;
      }

      this.dataCountrySelection = countryObj;
      this.$emit('ids-geog-filter-change', 'country', countryObj);

      if (!skipReset) {
        this.resetRegion(); // reset data and UI
      }

      if (countryObj) {
        // show loading indicator
        this.regionLoading = true;
        // load dependent data
        this.regions = await DgdDataLoader.getRegionList(countryObj.clientId, this.locationType);
        // hide loading indicator
        this.regionLoading = false;
      }
    },
    /**
     * Sets the new region selection and loads underlying districts.
     */
    async setNewRegion (regionObj, skipReset) {
      if (regionObj.clientId === null) {
        this.resetRegion();
        return;
      }

      this.dataRegionSelection = regionObj;
      this.$emit('ids-geog-filter-change', 'region', regionObj);

      if (!skipReset) {
        this.resetDistrict(); // reset data and UI
      }

      if (regionObj) {
        // show loading indicator
        this.districtLoading = true;
        // load dependent data
        this.districts = await DgdDataLoader.getDistrictList(
          this.dataCountrySelection.clientId, regionObj.clientId, this.locationType
        );
        // hide loading indicator
        this.districtLoading = false;
      }
    },
    /**
     * Sets the new district selection.
     */
    setNewDistrict (districtObj) {
      if (districtObj.clientId === null) {
        this.resetDistrict();
        return;
      }

      this.dataDistrictSelection = districtObj;
      this.$emit('ids-geog-filter-change', 'district', districtObj);
    },

    /**
     * Resets the country data and selection in UI
     */
    resetCountry () {
      this.dataCountrySelection = null;

      if (this.$refs && this.$refs.idsCountrySelector) {
        this.$refs.idsCountrySelector.dataSelection = null; // workaround
      }

      this.$emit('ids-geog-filter-change', 'country', null);
    },

    /**
     * Resets the region data and selection in UI
     */
    resetRegion () {
      // first reset underlying district selector
      this.resetDistrict();

      this.dataRegionSelection = null;

      if (this.$refs && this.$refs.idsRegionSelector) {
        this.$refs.idsRegionSelector.dataSelection = null; // workaround
      }

      this.$emit('ids-geog-filter-change', 'region', null);
    },
    /**
     * Resets the district data and selection in UI
     */
    resetDistrict () {
      this.dataDistrictSelection = null;

      if (this.$refs && this.$refs.idsDistrictSelector) {
        this.$refs.idsDistrictSelector.dataSelection = null; // workaround
      }

      this.$emit('ids-geog-filter-change', 'district', null);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// app/ids/components/filter/IdsGeographicFilter.vue